<div id="dashboard">
  <main>
    <div class="container">
      <div class="row">
        <aside class="col-md-3 px-0">
          <div class="filters" (click)="toggleFilterPane()">
            <hyperkit-typography variant="h5" align="left" color="primary">Filters</hyperkit-typography>
            
            <i class="k-icon k-font-icon k-i-arrow-chevron-left"></i>
          </div>
          <cyborg-all-active-filters></cyborg-all-active-filters>
          <div class="library">
            <hyperkit-typography variant="h6" align="left" color="primary">Library</hyperkit-typography>
            <ul>
              <li>
                <hyperkit-checkbox 
                (click)="onLibraryFilter(cyborgIndexEnum.CYBORG_COLLECTIONS)"                
                [checked]="
                (searchState$ | async).library.includes(
                  cyborgIndexEnum.CYBORG_COLLECTIONS
                ) && (searchState$ | async).touched == true"
                label="Hunt Package Collections"
               >
              </hyperkit-checkbox>   
              <hyperkit-typography variant="label2" align="left" color="inactive">{{collectionCount}}</hyperkit-typography>
              </li>
              <li>
                  <hyperkit-checkbox 
                  (click)="onLibraryFilter(cyborgIndexEnum.CYBORG_USE_CASES)"
                  [checked]="
                      (searchState$ | async).library.includes(
                        cyborgIndexEnum.CYBORG_USE_CASES
                      ) && (searchState$ | async).touched == true
                    "
                  label="Hunt Packages"
                 >
                </hyperkit-checkbox>                
                <hyperkit-typography variant="label2" align="left" color="inactive">{{huntPackageCount}}</hyperkit-typography>
              </li>
              <li>
                  <hyperkit-checkbox 
                  (click)="
                      onLibraryFilter(cyborgIndexEnum.CYBORG_THREAT_PROFILES)
                    "
                  [checked]="
                  (searchState$ | async).library.includes(
                    cyborgIndexEnum.CYBORG_THREAT_PROFILES
                  ) && (searchState$ | async).touched == true
                "
                  label="Threat Profiles"
                 >
                </hyperkit-checkbox>
                <hyperkit-typography variant="label2" align="left" color="inactive">{{profileCount}}</hyperkit-typography>
              </li>
            </ul>
          </div>

          <div class="mitre">
            <hyperkit-typography variant="h6" align="left" color="primary">MITRE</hyperkit-typography>
            <hyperkit-search-input
                  placeholder="Search MITRE"
                  (input)="onMitreSearch($event.target)"
                ></hyperkit-search-input>
            <cyborg-filter
              [filterData]="tag"
              *ngFor="let tag of filteredMitre"
              [events]="mitreTagsSubject"
            ></cyborg-filter>
          </div>

          <div class="relevant">
            <hyperkit-typography variant="h6" align="left" color="primary">Goals</hyperkit-typography>
            <cyborg-filter
              [filterData]="tag"
              *ngFor="let tag of filteredGoals"
            ></cyborg-filter>

            <hyperkit-typography variant="h6" align="left" color="primary">Tools</hyperkit-typography>
            <cyborg-filter
              [filterData]="tag"
              *ngFor="let tag of filteredTools"
            ></cyborg-filter>

            <hyperkit-typography variant="h6" align="left" color="primary">Platform Types</hyperkit-typography>
            <cyborg-filter
              [filterData]="tag"
              *ngFor="let tag of filteredPlatformTypes"
            ></cyborg-filter>

            <hyperkit-typography variant="h6" align="left" color="primary">Dependencies</hyperkit-typography>
            <cyborg-filter
              [filterData]="tag"
              *ngFor="let tag of filteredDependencyTypes"
            ></cyborg-filter>
          </div>

          <div class="relevant">
            <hyperkit-typography variant="h6" align="left" color="primary">Contextual Tagging</hyperkit-typography>
            <hyperkit-search-input
            placeholder="Search tags"
            (input)="onContextualSearch($event.target)"
          ></hyperkit-search-input>
            <cyborg-filter
              [filterData]="tag"
              *ngFor="let tag of filteredTags"
              [events]="contextualTagsSubject"
            ></cyborg-filter>
          </div>

          <div class="last-updated">
            <hyperkit-typography variant="h6" align="left" color="primary">Last Updated</hyperkit-typography>
            <ul>
              <li>
                <div class="radio">
                  <hyperkit-radio-button 
                  name="last_updated" 
                  value="1"
                  text="1 Day ago"
                  (click)="onLastUpdated($event.target)"
                  >
                </hyperkit-radio-button>
                </div>
              </li>
              <li>
                <div class="radio">
                  <hyperkit-radio-button 
                name="last_updated" 
                value="7"
                text="7 Days ago"
                (click)="onLastUpdated($event.target)"
                >
              </hyperkit-radio-button>
                </div>
              </li>
              <li>
                <div class="radio">
                  <hyperkit-radio-button 
                  name="last_updated" 
                  value="45"
                  text="45 Days ago"
                  (click)="onLastUpdated($event.target)"
                  >
                </hyperkit-radio-button>
                </div>
              </li>
              <li>
                <div class="radio">
                  <hyperkit-radio-button 
                  name="last_updated" 
                  value="90"
                  text="90 Days ago"
                  (click)="onLastUpdated($event.target)"
                  >
                </hyperkit-radio-button>
                </div>
              </li>
            </ul>
          </div>
        </aside>
        <div class="dash col-12 col-lg-9 px-0">
              <form [formGroup]="searchForm" (submit)="onSearch()">
                  <hyperkit-search-input
                  class="hyperkit-component"
                  placeholder="Search mitre, actors, tags etc..."
                  (search)="onSearch()"
                  formControlName="search"
                ></hyperkit-search-input>
              </form>
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </main>
</div>
